"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Green_500 = exports.Green_400 = exports.Green_300 = exports.Green_200 = exports.Green_100 = exports.Red_1400 = exports.Red_1300 = exports.Red_1200 = exports.Red_1100 = exports.Red_1000 = exports.Red_900 = exports.Red_800 = exports.Red_700 = exports.Red_600 = exports.Red_500 = exports.Red_400 = exports.Red_300 = exports.Red_200 = exports.Red_100 = exports.Blue_1500 = exports.Blue_1400 = exports.Blue_1300 = exports.Blue_1200 = exports.Blue_1100 = exports.Blue_1000 = exports.Blue_900 = exports.Blue_800 = exports.Blue_700 = exports.Blue_600 = exports.Blue_500 = exports.Blue_400 = exports.Blue_300 = exports.Blue_200 = exports.Blue_100 = exports.Gray_1600 = exports.Gray_1500 = exports.Gray_1400 = exports.Gray_1300 = exports.Gray_1200 = exports.Gray_1100 = exports.Gray_1000 = exports.Gray_900 = exports.Gray_800 = exports.Gray_700 = exports.Gray_600 = exports.Gray_500 = exports.Gray_400 = exports.Gray_300 = exports.Gray_200 = exports.Gray_100 = void 0;
exports.rioPrimaryButtonColors = exports.rioBuyNowButtonColors = exports.rioBoxColors = exports.rioAlertColors = exports.rioTextColors = exports.Orange_1500 = exports.Orange_1400 = exports.Orange_1300 = exports.Orange_1200 = exports.Orange_1100 = exports.Orange_1000 = exports.Orange_900 = exports.Orange_800 = exports.Orange_700 = exports.Orange_600 = exports.Orange_500 = exports.Orange_400 = exports.Orange_300 = exports.Orange_200 = exports.Orange_100 = exports.Yellow_1500 = exports.Yellow_1400 = exports.Yellow_1300 = exports.Yellow_1200 = exports.Yellow_1100 = exports.Yellow_1000 = exports.Yellow_900 = exports.Yellow_800 = exports.Yellow_700 = exports.Yellow_600 = exports.Yellow_500 = exports.Yellow_400 = exports.Yellow_300 = exports.Yellow_200 = exports.Yellow_100 = exports.Green_1400 = exports.Green_1300 = exports.Green_1200 = exports.Green_1100 = exports.Green_1000 = exports.Green_900 = exports.Green_800 = exports.Green_700 = exports.Green_600 = void 0;
exports.Gray_100 = '#0F1111';
exports.Gray_200 = '#181A1A';
exports.Gray_300 = '#303333';
exports.Gray_400 = '#494D4D';
exports.Gray_500 = '#565959';
exports.Gray_600 = '#6F7373';
exports.Gray_700 = '#888C8C';
exports.Gray_800 = '#969999';
exports.Gray_900 = '#A2A6A6';
exports.Gray_1000 = '#BBBFBF';
exports.Gray_1100 = '#C8CCCC';
exports.Gray_1200 = '#D5D9D9';
exports.Gray_1300 = '#E3E6E6';
exports.Gray_1400 = '#F0F2F2';
exports.Gray_1500 = '#F7FAFA';
exports.Gray_1600 = '#FFFFFF';
exports.Blue_100 = '#054B59';
exports.Blue_200 = '#0C3353';
exports.Blue_300 = '#006275';
exports.Blue_400 = '#2162A1';
exports.Blue_500 = '#008296';
exports.Blue_600 = '#246FB6';
exports.Blue_700 = '#23A4BA';
exports.Blue_800 = '#3DB7CC';
exports.Blue_900 = '#50C4D9';
exports.Blue_1000 = '#6ED6E6';
exports.Blue_1100 = '#91DFEB';
exports.Blue_1200 = '#C8F3FA';
exports.Blue_1300 = '#DEFAFF';
exports.Blue_1400 = '#EDFEFF';
exports.Blue_1500 = '#F7FEFF';
exports.Red_100 = '#850928';
exports.Red_200 = '#94042B';
exports.Red_300 = '#A6072C';
exports.Red_400 = '#BA0933';
exports.Red_500 = '#CC0C39';
exports.Red_600 = '#DB1846';
exports.Red_700 = '#EB1745';
exports.Red_800 = '#FC384F';
exports.Red_900 = '#FF4D5B';
exports.Red_1000 = '#FF6E70';
exports.Red_1100 = '#FF8C8C';
exports.Red_1200 = '#FFADAD';
exports.Red_1300 = '#FFC7C7';
exports.Red_1400 = '#FFE3E3';
exports.Green_100 = '#135C50';
exports.Green_200 = '#066354';
exports.Green_300 = '#04705B';
exports.Green_400 = '#067D62';
exports.Green_500 = '#009674';
exports.Green_600 = '#12B08C';
exports.Green_700 = '#13BD96';
exports.Green_800 = '#3CC9A6';
exports.Green_900 = '#56D6B6';
exports.Green_1000 = '#72E0C5';
exports.Green_1100 = '#92F0D8';
exports.Green_1200 = '#AFFAE7';
exports.Green_1300 = '#CCFCED';
exports.Green_1400 = '#E8FFF8';
exports.Yellow_100 = '#E09600';
exports.Yellow_200 = '#E69D00';
exports.Yellow_300 = '#E8A600';
exports.Yellow_400 = '#EBB000';
exports.Yellow_500 = '#F0B800';
exports.Yellow_600 = '#F2C200';
exports.Yellow_700 = '#F7CA00';
exports.Yellow_800 = '#FCD200';
exports.Yellow_900 = '#FFD814';
exports.Yellow_1000 = '#FFE147';
exports.Yellow_1100 = '#FFE873';
exports.Yellow_1200 = '#FFED94';
exports.Yellow_1300 = '#FFF1AD';
exports.Yellow_1400 = '#FFF6C7';
exports.Yellow_1500 = '#FFFAE0';
exports.Orange_100 = '#DE7921';
exports.Orange_200 = '#E37719';
exports.Orange_300 = '#EB7B13';
exports.Orange_400 = '#F78307';
exports.Orange_500 = '#FA8900';
exports.Orange_600 = '#FF8F00';
exports.Orange_700 = '#FFA41C';
exports.Orange_800 = '#FFAF38';
exports.Orange_900 = '#FFB952';
exports.Orange_1000 = '#FFC663';
exports.Orange_1100 = '#FFCE7A';
exports.Orange_1200 = '#FFD894';
exports.Orange_1300 = '#FFE4AD';
exports.Orange_1400 = '#FFEEC7';
exports.Orange_1500 = '#FFF8E5';
exports.rioTextColors = {
    base: exports.Gray_100,
    secondary: exports.Gray_500,
    disabled: exports.Gray_600,
    inverse: exports.Gray_1600,
    success: '#007600',
    link: exports.Blue_400,
    linkHover: exports.Blue_200
};
exports.rioAlertColors = {
    success: exports.Green_400,
    information: exports.Blue_600,
    warning: exports.Orange_800,
    error: exports.Red_500
};
exports.rioBoxColors = {
    boxBorder: exports.Gray_1200,
    divider: exports.Gray_1200
};
exports.rioBuyNowButtonColors = {
    foreground: exports.rioTextColors.base,
    background: exports.Orange_700,
    border: exports.Orange_600,
    backgroundHover: exports.Orange_500,
    borderHover: '#E3931E',
    backgroundFocus: exports.Gray_1600,
    borderFocus: exports.Orange_700
};
exports.rioPrimaryButtonColors = {
    foreground: exports.rioTextColors.base,
    background: exports.Yellow_900,
    border: exports.Yellow_800,
    backgroundHover: exports.Yellow_700,
    borderHover: exports.Yellow_600,
    backgroundFocus: exports.Gray_1600,
    borderFocus: exports.Yellow_900
};
